import ServicePage from '@/components/ServicePage';

export default function CustomDevelopmentPage() {
  return (
    <ServicePage
      slug="custom-development"
      title="Custom Software Development Services"
      titleAr="خدمات التطوير المخصصة"
      description="Build tailored software solutions that match your exact business needs. From web applications to mobile apps, our Egyptian development team delivers high-quality, scalable custom software."
      descriptionAr="ابن حلول برمجية مخصصة تتوافق مع احتياجات عملك بالضبط. من تطبيقات الويب إلى تطبيقات الهاتف المحمول، يقدم فريق التطوير المصري لدينا برمجيات مخصصة عالية الجودة وقابلة للتوسع."
      keywords="custom development services, custom software development, bespoke software solutions, web application development, mobile app development Egypt, software development company"
      heroImage="https://readdy.ai/api/search-image?query=Custom%20software%20development%20team%20brainstorming%20in%20modern%20office%2C%20whiteboard%20with%20architecture%20diagrams%2C%20developers%20collaborating%20on%20laptops%2C%20clean%20minimal%20workspace%2C%20professional%20corporate%20photography%2C%20warm%20lighting%2C%20blue%20accents&width=1400&height=600&seq=svc2&orientation=landscape"
      icon="ri-code-s-slash-line"
      features={[
        {
          title: 'Web Application Development',
          titleAr: 'تطوير تطبيقات الويب',
          description: 'We build responsive, high-performance web apps using React, Next.js, Vue, and Angular. From dashboards to e-commerce platforms, every app is built for scale.',
          descriptionAr: 'نبني تطبيقات ويب متجاوبة وعالية الأداء باستخدام React و Next.js و Vue و Angular. من لوحات المعلومات إلى منصات التجارة الإلكترونية، يتم بناء كل تطبيق للتوسع.',
        },
        {
          title: 'Mobile App Development',
          titleAr: 'تطوير تطبيقات الهاتف المحمول',
          description: 'Cross-platform apps with Flutter and React Native, plus native iOS and Android development when performance is critical. We handle the full lifecycle from design to deployment.',
          descriptionAr: 'تطبيقات متعددة المنصات مع Flutter و React Native، بالإضافة إلى تطوير iOS و Android الأصلي عندما يكون الأداء حاسماً. نتعامل مع دورة الحياة الكاملة من التصميم إلى النشر.',
        },
        {
          title: 'API Development & Integration',
          titleAr: 'تطوير API والتكامل',
          description: 'We design RESTful and GraphQL APIs that connect your systems seamlessly. Integration with third-party services, payment gateways, and legacy systems is our specialty.',
          descriptionAr: 'نصمم RESTful و GraphQL APIs التي تربط أنظمتك بسلاسة. التكامل مع خدمات الطرف الثالث، وبوابات الدفع، والأنظمة القديمة هو تخصصنا.',
        },
        {
          title: 'Database Design & Architecture',
          titleAr: 'تصميم قواعد البيانات والبنية',
          description: 'Scalable database design using PostgreSQL, MongoDB, MySQL, and Redis. We design schemas, optimize queries, and implement replication and sharding strategies.',
          descriptionAr: 'تصميم قاعدة بيانات قابلة للتوسع باستخدام PostgreSQL و MongoDB و MySQL و Redis. نصمم المخططات، ونحسن الاستعلامات، وننفذ استراتيجيات النسخ المتماثل والتجزئة.',
        },
        {
          title: 'Legacy System Modernization',
          titleAr: 'تحديث الأنظمة القديمة',
          description: 'We modernize outdated applications by refactoring code, migrating to modern frameworks, and improving architecture without disrupting business operations.',
          descriptionAr: 'نحدث التطبيقات القديمة من خلال إعادة هيكلة الكود، والترحيل إلى الأطر الحديثة، وتحسين البنية دون تعطيل عمليات الأعمال.',
        },
        {
          title: 'AI-Powered Features',
          titleAr: 'ميزات مدعومة بالذكاء الاصطناعي',
          description: 'Integrate AI capabilities into your software: chatbots, recommendation engines, image recognition, natural language processing, and predictive analytics.',
          descriptionAr: 'تكامل إمكانات الذكاء الاصطناعي في برمجياتك: chatbots، ومحركات التوصية، والتعرف على الصور، ومعالجة اللغة الطبيعية، والتحليلات التنبؤية.',
        },
      ]}
      benefits={[
        {
          title: 'Tailored to Your Business',
          titleAr: 'مخصص لعملك',
          description: 'Unlike off-the-shelf software, our custom solutions are built around your workflows, branding, and unique requirements. No compromises, no workarounds.',
          descriptionAr: 'على عكس البرمجيات الجاهزة، يتم بناء حلولنا المخصصة حول سير عملك، وعلامتك التجارية، ومتطلباتك الفريدة. لا تنازلات، لا حلول بديلة.',
        },
        {
          title: 'Full-Stack Expertise',
          titleAr: 'خبرة متكاملة',
          description: 'Our Egyptian team includes frontend developers, backend engineers, mobile specialists, DevOps experts, and UI/UX designers. One team, end-to-end delivery.',
          descriptionAr: 'يتضمن فريقنا المصري مطورين الواجهة الأمامية، ومهندسي الواجهة الخلفية، ومتخصصي الهاتف المحمول، وخبراء DevOps، ومصممي UI/UX. فريق واحد، تسليم شامل.',
        },
        {
          title: 'Agile Development Process',
          titleAr: 'عملية تطوير Agile',
          description: 'Bi-weekly sprints with demos, continuous feedback, and transparent progress tracking. You see your product evolve and can pivot quickly based on market feedback.',
          descriptionAr: 'سبعات كل أسبوعين مع عروض توضيحية، وملاحظات مستمرة، وتتبع التقدم الشفاف. ترى منتجك يتطور ويمكنك التحول بسرعة بناءً على ملاحظات السوق.',
        },
        {
          title: 'Scalable Architecture',
          titleAr: 'بنية قابلة للتوسع',
          description: 'We build with growth in mind. Microservices, serverless, containerization, and cloud-native patterns ensure your software handles 10x traffic without breaking.',
          descriptionAr: 'نبني مع النمو في الاعتبار. تضمن الخدمات المصغرة، وبدون خادم، والحاويات، وأنماط أصلية السحابة أن برمجياتك تتعامل مع حركة مرور 10x دون انقطاع.',
        },
      ]}
      faqs={[
        {
          question: 'How long does a custom development project take?',
          questionAr: 'كم تستغرق مشروع التطوير المخصص؟',
          answer: 'Project timelines vary by scope. A simple web app takes 4-8 weeks. A complex platform with mobile apps, APIs, and admin dashboards typically takes 3-6 months. We provide detailed estimates before starting.',
          answerAr: 'تختلف الجداول الزمنية للمشروع حسب النطاق. يستغرق تطبيق ويب بسيط 4-8 أسابيع. تستغرق المنصة المعقدة مع تطبيقات الهاتف المحمول، وAPIs، ولوحات المعلومات الإدارية عادة 3-6 أشهر. نقدم تقديرات مفصلة قبل البدء.',
        },
        {
          question: 'What technologies do you use for custom development?',
          questionAr: 'ما هي التقنيات التي تستخدمونها للتطوير المخصص؟',
          answer: 'Frontend: React, Next.js, Vue, Angular. Backend: Node.js, Python (Django/FastAPI), PHP (Laravel), Java (Spring Boot). Mobile: Flutter, React Native, Swift, Kotlin. Cloud: AWS, Azure, GCP, Firebase.',
          answerAr: 'الواجهة الأمامية: React، Next.js، Vue، Angular. الواجهة الخلفية: Node.js، Python (Django/FastAPI)، PHP (Laravel)، Java (Spring Boot). الهاتف المحمول: Flutter، React Native، Swift، Kotlin. السحابة: AWS، Azure، GCP، Firebase.',
        },
        {
          question: 'Do you own the code after the project is complete?',
          questionAr: 'هل تمتلكون الكود بعد اكتمال المشروع؟',
          answer: 'No. All intellectual property rights are transferred to you upon project completion. You receive full source code, documentation, and deployment instructions. We can also provide ongoing maintenance.',
          answerAr: 'لا. يتم نقل جميع حقوق الملكية الفكرية إليك عند اكتمال المشروع. تستلم الكود المصدري الكامل، والتوثيق، وتعليمات النشر. يمكننا أيضاً تقديم صيانة مستمرة.',
        },
      ]}
      relatedServices={[
        { slug: 'bug-fixing', title: 'Bug Fixing & Debugging', titleAr: 'إصلاح الأخطاء والتصحيح', icon: 'ri-bug-line' },
        { slug: 'cloud-services', title: 'Cloud Services', titleAr: 'الخدمات السحابية', icon: 'ri-cloud-line' },
        { slug: 'workplace-automation', title: 'Workplace Automation', titleAr: 'أتمتة مكان العمل', icon: 'ri-settings-3-line' },
      ]}
    />
  );
}